
import { SHIFT_BOOST_TYPES } from '@/shared/constants/shifts'
import shiftsTransformer from './shifts-transformer'
import gigCreator from './gig-creator'

// import useGigList from '../gig-list/useGigList'
// const {onGigCreateEdit} = useGigList()
const createBoostStatus = (isBoosted, boostedOption, boostedValue) => ({
  boosted: isBoosted, 
  boostedOptions: isBoosted ? {
    boostType: boostedOption.value,
    value: boostedOption.value === SHIFT_BOOST_TYPES.quick.value ? '' : boostedValue
  } : {}
})

const processParams = ({
  selectedAccount, assignedArea, contract,
  isBoosted, selectedBoostedOption, selectedBoostedValue, 
  updateStates,
  inputShifts, // original shifts data
  form,
  status,
}) => {
  // *: for order (whatever not applicable will hav a default value e.g [], undefined etc)
  const areaInfo = { // for campaign
    accountId: selectedAccount.value.id, // * from order.accountId
    // * from area obj
    sectionInfo: form.location.sectionInfo, // TODO location may be a better name
    areaId: assignedArea.id,
    category: assignedArea.category || selectedAccount.value.category,
    contractId: contract.id,
    salary: contract.salary,
  }

  const boostStatus = createBoostStatus(
    isBoosted, // * false
    selectedBoostedOption, // * empty string
    selectedBoostedValue // * empty string
  )

  return {areaInfo, boostStatus, updateStates, form, inputShifts, status}
}

// check if any shift has falsy value for start and end
const isAllShiftsValid = shifts => shifts && shifts.some(shift => shift.start !== null || shift.end !== null)

const createShiftsAndGig = async params => {
  const {areaInfo, boostStatus, updateStates, form, inputShifts, status } = processParams(params)
  const shiftsData = await shiftsTransformer.transformShifts(inputShifts, {areaInfo, boostStatus, updateStates})
  return isAllShiftsValid(shiftsData.shifts) ? { 
    shifts: shiftsData.shifts, 
    gig: gigCreator.createGig({areaInfo, boostStatus, form, shiftsData, status })
  } : null
}

/* // TODO does not work
const publish = async (params, isEditing) => {
  const {shifts, gig} = await createShiftsAndGig(params)
  if (gig) {
    await onGigCreateEdit({shifts, gig, isEditing})
  }else {
    throw new Error('publish error')
  }
}

// usage in component e.g GigListAddNew.vue
/*
try {
  await gigPublisher.publish(params, this.isEditing)
  this.$bvModal.hide('create-gig-modal')
} catch (error) {
  this.$toast(hwToast.error({title: 'not all shifts are valid', text: 'Please check shift times, something went wrong.'}))
}        
*/

const gigPublisher = {
  createShiftsAndGig,
}

export default gigPublisher